module.exports = __webpack_public_path__ + "img/mcgl_tyg_05.a3a5645e.png";